import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { withAPIService } from '../../../../networking';
import { deleteShipToDialog } from '../../../../shared/dialogConfigs';
import { withStore } from '../../../../store';
import { updateField } from '../../../../store/customer';
import { openDialog } from '../../../../store/dialog';
import { getAddressString } from '../../../../utils/hooksLib';
import type { CardApiService, CardDispatch, CardStore } from '../../types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-end;
`;

const DeleteShipToText = styled.span`
  color: #1589ee;
  cursor: pointer;
`;

interface DeleteShipToProps {
  store: CardStore;
  apiService: CardApiService;
  dispatch: CardDispatch;
  index: number;
}

function DeleteShipTo({ store, apiService, dispatch, index }: DeleteShipToProps) {
  const shipTo = store.customer.shipTo[index];
  const { id, sfdcId } = shipTo;

  const deleteShipTo = (shipToId: string) => {
    const newShipTo = store.customer.shipTo.filter(({ id }: { id: string }) => id !== shipToId);
    dispatch(updateField({ name: 'shipTo', value: newShipTo }));
    apiService.updateCustomer({ ...store.customer, shipTo: newShipTo }, dispatch);
  };

  const onDeleteShipToIconClick = () => {
    const primaryEvent = () => deleteShipTo(id);
    const address = getAddressString(shipTo.address);
    dispatch(openDialog(deleteShipToDialog(primaryEvent, address)));
  };
  const { t } = useTranslation();
  return (
    <Wrapper>
      {!sfdcId && (
        <DeleteShipToText
          onClick={e => {
            e.stopPropagation();
            onDeleteShipToIconClick();
          }}
        >
          {t('buttons.deleteShipTo')}
        </DeleteShipToText>
      )}
    </Wrapper>
  );
}

export default withAPIService(withStore(DeleteShipTo));
